module.exports = "<div class=\"consumer-type-popup\">\r\n    <create-edit-popup ng-if=\"options\" options=\"options\"></create-edit-popup>\r\n</div>\r\n"